import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { SearchField, TitleBar, Container, Button, Menu, MenuItem } from '@sencha/ext-modern'
import { doLogout } from '../../reducers/actions'
function AppTitle(props) {
	const { showSearchForPhone, onClick, doLogout, onSearch, query, allTaskList, onSelectType, selectedTaskType, type } = props
	let taskType = []
	allTaskList && allTaskList.forEach((item) => {
		if (!taskType.includes(item.title)) {
			taskType.push(item.title)
		}
	})
	return (
		<Container>
			<TitleBar title={type && "我的签核任务" || "我的任务"} titleAlign="center" docked="top">
				<Button align="left" iconCls="x-fa fa-bars" arrow={false}>
					<Menu>
						{taskType && taskType.map((item, index) => (
							<MenuItem key={index} text={item} iconCls={item === selectedTaskType ? "x-fa fa-circle" : "x-fa fa-circle-thin"} onClick={onSelectType} />
						))}
						<MenuItem text="全部" iconCls={selectedTaskType === "全部" ? "x-fa fa-circle" : "x-fa fa-circle-thin"} onClick={onSelectType} />
					</Menu>
				</Button>
				{Ext.os.is.Phone && (
					<Button align="right" iconCls={showSearchForPhone ? "x-fa fa-times" : "x-fa fa-search"} handler={onClick} />
				)}
				{!Ext.os.is.Phone && (
					<SearchField align="right" ui="alt" placeholder="查找" margin="0 10" value={query} onChange={onSearch} />
				)}
			</TitleBar>
			{Ext.os.is.Phone && showSearchForPhone && (
				<SearchField ui="faded" placeholder="查找" margin="20" value={query} onChange={onSearch} />
			)}
		</Container>
	)
}


const mapStateToProps = ({ loginInfo: { userName } }) => ({
	userName,
})

export default compose(
	connect(mapStateToProps, { doLogout }),
)(AppTitle)

